module.exports = __webpack_public_path__ + "img/hnec2.d8ad048d.jpg";